import { FC } from 'react';
import { DotSpinner } from '@crono-one/design-system';

import PATH from 'crono-fe-common/constants/path';
import useHubspotAuthCallback from 'hooks/services/hubspot/useHubspotAuthCallback';
import { useAuth } from 'context/auth';
import IntegrationType from 'crono-fe-common/types/enums/integrationType';
import useOauthCallbackCode from 'pages/connect/views/useOauthCallbackCode';
import storeOnboardingError from 'pages/connect/views/storeOnboardingError';

const HubspotLoginHandler: FC = () => {
  const { refreshUser } = useAuth();
  const { mutate: hubspotAuthCallback } = useHubspotAuthCallback();

  useOauthCallbackCode({
    provider: 'HubSpot',
    exchangeCode: hubspotAuthCallback,
    buildVariables: (code) => ({ code }),
    missingCodePath: PATH.CONNECT,
    successPath: PATH.SETTINGS.INTEGRATIONS.MAIN,
    errorPath: PATH.CONNECT,
    onSuccess: refreshUser,
    onError: (error) => storeOnboardingError(error, IntegrationType.HUBSPOT),
  });

  return (
    <div className="flex h-full w-full items-center justify-center">
      <DotSpinner />
    </div>
  );
};

export default HubspotLoginHandler;
